import React from 'react';

import { PageWrapperStyle } from './style';

// eslint-disable-next-line react/prop-types
export default function PageWrapper({ children }) {
  return <PageWrapperStyle>{children}</PageWrapperStyle>;
}
